"use client";

import { SuperLink as Link } from "@/components/common/super-link";
import { createPath } from "@/service/routing/routing";
import { usePathname, useSearchParams } from "next/navigation";
import { Button } from "@/components/ui/button";
import { extractSearchParamsFromString } from "@/lib/utils";

export const ButtonNav = ({
  navItems,
  ignoreSearchParams = false,
}: {
  navItems: {
    link: string;
    searchParams?: Record<string, string>;
    title: string;
    isActive?: boolean;
  }[];
  ignoreSearchParams?: boolean;
  theme?:
    | "publication"
    | "e-book"
    | "vademecum"
    | "tutorial"
    | "fast_question"
    | "video";
}) => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const currentSearchParams = !ignoreSearchParams
    ? Object.fromEntries(searchParams.entries())
    : {};

  return (
    <div
      className={
        "@container mb-6 flex flex-col justify-between gap-8 border-b-[1px] pb-6 sm:flex-row xl:mb-8 xl:pb-8"
      }
    >
      <div className={"flex flex-wrap items-center gap-2"}>
        {navItems.map(
          ({ link, title, isActive, searchParams: queryParams }) => {
            const isSeries =
              pathname.includes(createPath("video.series")) &&
              link.includes(createPath("video.series"));
            const checkPath = isActive === undefined;
            const searchParamsFromLink = extractSearchParamsFromString(link);

            return (
              <Button
                variant={
                  (checkPath && (isActive || link == pathname || isSeries)) ||
                  isActive
                    ? "blue"
                    : "secondary"
                }
                key={title}
                asChild={true}
              >
                <Link
                  href={{
                    pathname: link.split("?")[0],
                    query: {
                      ...currentSearchParams,
                      ...searchParamsFromLink,
                      ...queryParams,
                    },
                  }}
                >
                  {/* h4 for SEO */}
                  <h4>{title}</h4>
                </Link>
              </Button>
            );
          },
        )}
      </div>
    </div>
  );
};
